import api from './axiosConfig';

/**
 * Activity detail without stream blobs (include_stream_data=0), merged with GET /streams.
 * Avoids loading + JSON.parse of large stream arrays in the main handler (server RSS/CPU).
 */
export async function fetchStravaActivityWithStreams(id) {
  const numericId = typeof id === 'string' ? id : String(id);
  const [mainRes, streamsRes] = await Promise.all([
    api.get(`/api/strava/activity/${numericId}?include_stream_data=0`),
    api.get(`/api/strava/activity/${numericId}/streams`).catch(() => ({ data: { streams: {} } })),
  ]);
  return {
    ...mainRes.data,
    streams: streamsRes.data?.streams || {},
  };
}
